import {useTranslation} from "react-i18next";
import Button from "./Button.jsx";

export default function Pagination({pagination, onPageChange, className}) {

    let {t} = useTranslation();

    if (pagination === undefined) {
        pagination = {
            firstItemIndex: 1,
            firstPage: 1,
            hasNextPage: false,
            hasPreviousPage: false,
            itemCount: 1,
            itemsPerPage: 1,
            lastItemIndex: 1,
            lastPage: 1,
            page: 1,
            pageCount: 1,
        }
    }

    let numbers = numberMaker(pagination.page, pagination.firstPage, pagination.lastPage);

    let commonButtonClassName = 'comp__roundedControl btn bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 select-none';
    let disabledButtonClassName = commonButtonClassName + ' text-slate-300 dark:text-slate-600';
    let enabledButtonClassName = commonButtonClassName + ' hover:border-slate-300 dark:hover:border-slate-600 text-indigo-500 cursor-pointer';


    return (
        <div className={className + ' comp__paginator'}>
            <nav className="flex justify-between" role="navigation" aria-label="Navigation">
                <div className="flex-1 mr-2">
                    <Button
                        variant={'outline-black'}
                        disabled={!pagination.hasPreviousPage}
                        onClick={() => {
                            onPageChange(Math.max(pagination.page - 1, pagination.firstPage));
                        }}
                    >
                        &lt;-<span className="hidden sm:inline">&nbsp;{t('page.previous')}</span>
                    </Button>
                </div>
                <div className="grow text-center">
                    <ul className="inline-flex text-sm font-medium gap-2">
                        {numbers.map((number, index) => {
                            if (number === null) {
                                return (
                                    <li key={number + index}>
                                        <span
                                            className="inline-flex items-center justify-center leading-5 px-2 py-2 text-slate-400 dark:text-slate-500"
                                        >
                                            …
                                        </span>
                                    </li>
                                );
                            }

                            let selectedNumberClassName = 'inline-flex items-center justify-center select-none rounded-full leading-5 px-2 py-2 bg-white dark:bg-slate-800 border border-gray-400 text-gray-600 shadow-sm';
                            let ordinaryNumberClassName = 'inline-flex items-center justify-center select-none leading-5 px-2 py-2 text-slate-600 dark:text-gray-300 hover:text-indigo-500 dark:hover:text-indigo-500 border border-transparent cursor-pointer';

                            return (
                                <li key={number + "-" + index}>
                                    <span
                                        className={number === pagination.page ? selectedNumberClassName : ordinaryNumberClassName}
                                        onClick={() => {
                                            onPageChange(number);
                                        }}
                                    >
                                        {number}
                                    </span>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div className="flex-1 text-right ml-2">
                    <Button
                        variant={'outline-black'}
                        disabled={!pagination.hasNextPage}
                        onClick={() => {
                            onPageChange(Math.min(pagination.page + 1, pagination.lastPage));
                        }}
                    >
                        <span className="hidden sm:inline">{t('page.next')}&nbsp;</span>-&gt;
                    </Button>
                </div>
            </nav>
        </div>
    );
}

export function numberMaker(page, min, max) {
    let numbers = [];

    let allowedNumbers = [min, max, page, page + 1, page - 1];

    let lastRendered = min - 1;
    for (let number = min; number <= max; number++) {

        if (lastRendered !== number - 1 && numbers[numbers.length - 1] !== null) {
            numbers.push(null);
        }

        if (allowedNumbers.includes(number)) {
            lastRendered = number;
            numbers.push(number);
        }
    }

    return numbers;
}
